import service from './service';
var protalBaseURL = process.env.VUE_APP_BASE_URL_IDM; // 根据手机号获取员工信息

export function getInternalByMobile(data) {
  return service({
    baseURL: protalBaseURL,
    url: 'v2/account/getInternalByMobile',
    method: 'post',
    data: data
  });
} // 发送探活待办

export function sendAccountProbe(data) {
  return service({
    baseURL: protalBaseURL,
    url: 'todo/accountProbe',
    method: 'post',
    data: data
  });
} // 获取探活待办详情

export function getOaProbeDetail(data) {
  return service({
    baseURL: protalBaseURL,
    url: 'todo/accountProbeDetail',
    method: 'post',
    data: data
  });
} // 确认探活待办详情

export function confirmAccountProbe(data) {
  return service({
    baseURL: protalBaseURL,
    url: 'todo/confirmAccountProbe',
    method: 'post',
    data: data
  });
} // 已发送待办，再登录

export function accountProbeTips(data) {
  return service({
    baseURL: protalBaseURL,
    url: 'todo/accountProbeTips',
    method: 'post',
    data: data
  });
} // 已发送待办，再登录

export function accountProbePreTips(data) {
  return service({
    baseURL: protalBaseURL,
    url: 'todo/accountProbePreTips',
    method: 'post',
    data: data
  });
}